$(document).ready(function() {
  // var playlistItem = $('.playlist .playlist__item');
  // var playlistFirstItem =  $('.playlist .playlist__item:first');
  // var videoID = playlistFirstItem.data('video');
  //
  // playlistItem.removeClass('playlist__item_active');
  // playlistFirstItem.addClass('playlist__item_active');

  // $('#player__video').attr('src','https://www.youtube.com/embed/' + videoID + '?rel=0&showinfo=0&autohide=1');

  /*
  if ($.fn.mCustomScrollbar) {
      $(".playlist .playlist__list").mCustomScrollbar({
          axis: "y",
          theme: "minimal-dark",
          //mouseWheelPixels: 1000,
          scrollInertia: 1000,
          advanced:{
              updateOnContentResize: true
          }
      });
  }
  */

  /* отложенная загрузка видео */
  let vidDefer = document.querySelectorAll('.js-deferred-video');
  for (let i=0; i < vidDefer.length; i++) {
    if(vidDefer[i].getAttribute('data-src')) {
      vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
    } }
});

$(document).on('click', '.js-playlist-item', function () {
  var videoID = $(this).data('video');
  var playlistItem = $('.js-playlist-item');

  var PlaylistItemActive = $(this).hasClass('playlist__item_active');

  if (!PlaylistItemActive) {
    playlistItem.removeClass('playlist__item_active');
    $(this).addClass('playlist__item_active');

    /*
    var playlistItemPosition = $(this).position().top;
    $('.playlist .playlist__list').mCustomScrollbar("scrollTo", playlistItemPosition);
    console.log(playlistItemPosition);
     */

    $('.js-player').attr('src','https://www.youtube.com/embed/' + videoID + '?autoplay=1&rel=0&showinfo=0&autohide=1&modestbranding=0&amp;');
  }
});



// WEBPACK FOOTER //
// ./src/static/scripts/video.js